import { render, staticRenderFns } from "./AffiliateWebsiteAndEvents.vue?vue&type=template&id=54314b7d"
import script from "./AffiliateWebsiteAndEvents.vue?vue&type=script&lang=ts"
export * from "./AffiliateWebsiteAndEvents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports